import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { isObject, stringBuilder } from '../util';
export const getId = (id, index) => `${id}_option_${index}`;
const TuxDefaultDropdown = (props, ref) => {
    const { bindLabel, disabled = false, className, focusedItemIndex, id, items, onSelect, readonly = false } = props;
    const dropdownItemRefs = useRef([]);
    const dropdownMenuRef = useRef(null);
    useImperativeHandle(ref, () => ({
        dropdownMenu: dropdownMenuRef.current,
        dropdownItems: dropdownItemRefs.current
    }));
    const handleClick = (item) => {
        if (disabled || readonly) {
            return;
        }
        onSelect(item);
    };
    return (_jsx("ul", Object.assign({ "aria-label": "list of items", className: stringBuilder('filter_options', className), id: id, ref: dropdownMenuRef, role: "listbox" }, { children: items.map((item, i) => (
        // disabling need for 'aria-selected' since announceChangeToScreen reader serves same purpose
        /* eslint-disable jsx-a11y/role-has-required-aria-props */
        _jsx("li", Object.assign({ className: stringBuilder('dropdown-item', {
                focus: i === focusedItemIndex
            }), id: getId(id, i), onClick: () => handleClick(item), ref: (itemRef) => {
                if (!!itemRef) {
                    dropdownItemRefs.current.push(itemRef);
                }
            }, role: "option", tabIndex: -1 }, { children: !!bindLabel && isObject(item) ? item[bindLabel] : item }), i)
        /* eslint-enable */
        )) }), void 0));
};
const TuxDefaultDropdownWrapper = forwardRef(TuxDefaultDropdown);
export default TuxDefaultDropdownWrapper;
